// extracted by mini-css-extract-plugin
export default {"sort":"dmq2_JDuqNk0guFg6qdv","sortText":"ZKfJSK_U8DBP8RZB3zqg"};